import { useQuery } from 'react-query';
import { IServiceParams } from '@interfaces/services';
import transactionsServices from 'src/services/transactions/axios/transactionsServices';
import { ITransactionsResponse, ITransactionDetailResponse, ITransactionsSummaryResponse, ITransactionsMetadataResponse } from '@interfaces/transactions';
import { filterLogEvent } from 'src/analitycs/pagesEvents/transactions';

interface UseGetTransactionsParams {
  serviceParams: IServiceParams;
  logInAmplitude?: boolean;
  cleanLogData?: () => void;
  removingFilters?: boolean;
}

export const useGetTransactions = ({
  serviceParams,
  logInAmplitude = false,
  cleanLogData,
  removingFilters = false
}: UseGetTransactionsParams) => {
  const query = useQuery<ITransactionsResponse, Error>(
    ['find-all-transactions', serviceParams.pagination, serviceParams.filterUrlParams],
    async () => {
      const transactions = await transactionsServices.findAll(serviceParams);
      if (logInAmplitude) {
        filterLogEvent(
          serviceParams.filterUrlParams,
          removingFilters,
          transactions.metadata.pagination.total_results
        );
        cleanLogData();
      }
      return transactions;
    },
    {
      enabled: true,
      retry: 1
    }
  );
  return query;
};

export const useGetTransactionsSummary = (filterUrlParams: Object) => {
  const query = useQuery<ITransactionsSummaryResponse, Error>(
    ['transactions-summary', filterUrlParams],
    async () => {
      return await transactionsServices.getTransactionsSummary(filterUrlParams);
    },
    {
      enabled: true,
      retry: 1
    }
  );
  return query;
};

export const useGetTransactionsMetadata = () => {
  const query = useQuery<ITransactionsMetadataResponse, Error>(
    ['transactions-metadata'],
    async () => {
      return await transactionsServices.getTransactionsMetadata();
    },
    {
      // Estable por sesión (H3/H4): las opciones de filtros no cambian durante el uso.
      staleTime: 5 * 60 * 1000,
      retry: 1
    }
  );
  return query;
};

export const useGetTransactionDetail = (transactionId: string) => {
  const query = useQuery<ITransactionDetailResponse, Error>(
    ['find-transaction-detail', transactionId],
    async () => {
      return await transactionsServices.findById(transactionId);
    },
    {
      enabled: !!transactionId,
      retry: 1
    }
  );
  return query;
};
